import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import {
	DeviceLicense,
	DeviceLicenseState,
	DeviceLicenseWarningDetails
} from '@shure/shared/angular/data-access/system-api/models';

@Injectable({
	providedIn: 'root'
})
export class DeviceLicenseStateTextService {
	constructor(private readonly transloco: TranslocoService) {}

	public getTitle(deviceLicenseState: DeviceLicenseState | undefined): string {
		let title = '';

		switch (deviceLicenseState) {
			case undefined:
			case DeviceLicenseState.ActivationConfirmed:
				break;
			case DeviceLicenseState.Unlicensed:
				title = this.transloco.translate('license.states.unlicensed.title');
				break;
			case DeviceLicenseState.GracePeriod:
				title = this.transloco.translate('license.states.grace-period.title');
				break;
			case DeviceLicenseState.WarningPeriod:
				title = this.transloco.translate('license.states.waring-period.title');
				break;
			case DeviceLicenseState.Expired:
				title = this.transloco.translate('license.states.expired.title');
				break;
			case DeviceLicenseState.CommunicationIssue:
				title = this.transloco.translate('license.states.communication-issue.title');
				break;
			case DeviceLicenseState.Insufficient:
				title = this.transloco.translate('license.states.insufficient.title');
				break;
			case DeviceLicenseState.ClockSetting:
				title = this.transloco.translate('license.states.clock-setting.title');
				break;
			case DeviceLicenseState.InvalidId:
				title = this.transloco.translate('license.states.invalid-id.title');
				break;
			case DeviceLicenseState.ActivationPending:
				title = this.transloco.translate('license.states.activation-pending.title');
				break;
			case DeviceLicenseState.DeactivationPending:
				title = this.transloco.translate('license.states.deactivation-pending.title');
				break;
			case DeviceLicenseState.UnknownIssue:
				title = this.transloco.translate('license.states.unknown-issue.title');
				break;
			default:
				throw new Error('Unhandled DeviceLicenseState: ' + deviceLicenseState);
		}

		return title;
	}

	public getDescription(deviceLicense: DeviceLicense<DeviceLicenseWarningDetails> | undefined): string {
		let description = '';

		if (!deviceLicense) {
			return description;
		}

		switch (deviceLicense.state) {
			case DeviceLicenseState.ActivationConfirmed:
				break;
			case DeviceLicenseState.Unlicensed:
				description = this.transloco.translate('license.states.unlicensed.description');
				break;
			case DeviceLicenseState.GracePeriod:
				description = this.transloco.translate('license.states.grace-period.description');
				break;
			case DeviceLicenseState.WarningPeriod:
				description = this.transloco.translate('license.states.waring-period.description');
				break;
			case DeviceLicenseState.Expired:
				description = this.transloco.translate('license.states.expired.description', {
					renewLicenseText: this.transloco.translate('license.common.renew-license')
				});
				break;
			case DeviceLicenseState.CommunicationIssue:
				description = this.transloco.translate('license.states.communication-issue.description');
				break;
			case DeviceLicenseState.Insufficient:
				description = this.transloco.translate('license.states.insufficient.description', {
					buyLicensesText: this.transloco.translate('license.common.buy-more-licenses')
				});
				break;
			case DeviceLicenseState.ClockSetting:
				description = this.transloco.translate('license.states.clock-setting.description', {
					persistingIssueText: this.transloco.translate('license.common.persisting-issue')
				});
				break;
			case DeviceLicenseState.InvalidId:
				description = this.transloco.translate('license.states.invalid-id.description');
				break;
			case DeviceLicenseState.ActivationPending:
				description = this.transloco.translate('license.states.activation-pending.description', {
					persistingIssueText: this.transloco.translate('license.common.persisting-issue')
				});
				break;
			case DeviceLicenseState.DeactivationPending:
				description = this.transloco.translate('license.states.deactivation-pending.description', {
					persistingIssueText: this.transloco.translate('license.common.persisting-issue')
				});
				break;
			case DeviceLicenseState.UnknownIssue:
				description = this.transloco.translate('license.states.unknown-issue.description', {
					persistingIssueText: this.transloco.translate('license.common.persisting-issue')
				});
				break;
			default:
				throw new Error('Unhandled DeviceLicenseState: ' + deviceLicense.state);
		}

		return description;
	}
}
